import { ListTablePaginated } from "../general_components/ListTablePaginated";
import { Grid, Card, CardContent, Typography, CardActions, IconButton } from "@mui/material";
import { getInformes, getInformeDetalle, getInformesPaginated2 } from "src/general_helpers/InformesData";
import Tooltip from "@mui/material/Tooltip";
import { GridActionsCellItem } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import { useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { Chip } from '@mui/material';
import InformeDetalle from "./InformeDetalle";
import createPDF from "src/general_components/InformeProduccionHtmlPdf";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import esArray from "src/general_components/functionEsArray";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import SearchForm from "src/general_components/SearchFormInformes";
import { HeaderTitleBreadcrumbs } from "src/general_components/HeaderTitle&Breadcrumbs";
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import { ConfimDialogComponent } from 'src/general_components/ConfirmDialogComponent';
import { estadoUpdate } from "src/projects/produccion/helpers/informesData";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import HistoryIcon from '@mui/icons-material/History';
import HistoricoCambioEstadoInformeProduccion from "src/general_components/HistoricoCambioEstadoInformeProduccion";
import HelpIcon from '@mui/icons-material/Help';
import { clientesForSearch, articulosForSearch, cuentasFisicasForSearch, estadosInformesForSearch } from "src/services/getDataInLocalStorage";

export const Informes = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [modalState, setModalState] = useState(false);
    const [childModal, setChildModal] = useState("");
    const [modalName, setModalName] = useState("Buscar");
    const [idElementData, setIdElementData] = useState(false);
    const [modalStateConfirm, setModalStateConfirm] = useState(false);
    const [modalStateRechazar, setModalStateRechazar] = useState(false);
    const [idPrdOrdenProduccion, setIdPrdOrdenProduccion] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const [actualizarListado, setActualizarListado] = useState(false);
    const [modalStateHistorico, setModalStateHistorico] = useState(false);
    const [historicoCambiosEstados, setHistoricoCambiosEstados] = useState([]);
    const [hideDisabled, setHideDisabled] = useState(false);
    const [tittleSnackbar, setTittleSnackbar] = useState(false);
    const [estadoInforme, setEstadoInforme] = useState(false);

    let user_data = JSON.parse(localStorage.getItem("siam-user-data"));
    let idPerfil = user_data.id_perfiles;

    const generarPDF = async (informe) => {
        const response = await createPDF(informe);
        return response;
    };

    const columns = [
        { field: "id", headerName: "ID", minWidth: 50, flex: 0.3 },
        { field: "numero", headerName: "Numero", minWidth: 100, flex: 1 },
        { field: "tecnico", headerName: "Tecnico", minWidth: 150, flex: 1 },
        { field: "fecha", headerName: "Fecha", minWidth: 150, flex: 1 },
        { field: "maquina_name", headerName: "Maquina", minWidth: 150, flex: 1 },
        { field: "cliente_name", headerName: "Cliente", minWidth: 200, flex: 1 },
        {
            field: "estado",
            headerName: "Estado",
            flex: 1,
            minWidth: 120,
            align: 'center',
            headerAlign: "center",
            renderCell: (params) => {
                const getColor = (estado) => {
                    switch (estado) {
                        case 'Confirmado':
                            return '#23A452';
                        case 'Rechazado':
                            return '#C70039';
                        default:
                            return '#2350A4';
                    }
                };

                return (
                    <Chip
                        label={params.value}
                        size="small"
                        sx={{
                            fontSize: '0.75rem',
                            height: '24px',
                            width: '80px',
                            backgroundColor: getColor(params.value),
                            color: 'white'
                        }}
                    />
                );
            }
        },
        {
            field: "actions",
            headerName: "Acciones",
            type: "actions",
            flex: 1,
            minWidth: 150,
            getActions: (params) => {
                // Definir las acciones
                let actions = [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Detalle">
                                <span>
                                    <VisibilityIcon color="info" />
                                </span>
                            </Tooltip>
                        }
                        onClick={async () => {
                            const datos = params.row;
                            setModalName("Detalles del Informe");
                            setChildModal(<InformeDetalle data={datos} />)
                            setModalState(true);
                        }}
                        label="Detalle"
                    />
                ];

                // Mostrar el botón "Confirmar Informe" solo si el idPerfil es 2 o 6
                if (idPerfil === "2" || idPerfil === "6") {
                    actions.push(
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Confirmar Informe">
                                    <span>
                                        <ThumbUpAltIcon color="success" />
                                    </span>
                                </Tooltip>
                            }
                            onClick={async () => {
                                setEstadoInforme(params.row.estado);
                                setIdPrdOrdenProduccion(params.row.id);
                                toggleModalConfirm();
                            }}
                            hidden={params.row.estado === "Confirmado" ? true : false}
                            label="Confirmar Informe"
                        />,
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Cambios de Estado">
                                    <span>
                                        <HistoryIcon color="secondary" />
                                    </span>
                                </Tooltip>
                            }
                            onClick={async () => {
                                const historicoEstados = params.row?.prdCambioEstados?.historico_estados || [];
                                handleHistorico(historicoEstados);
                            }}

                            label="Confirmar Informe"
                        />
                    );
                }

                // Mostrar el botón "Rechazar Informe" solo si el idPerfil es 2 o 6
                if (idPerfil === "2" || idPerfil === "6") {
                    actions.push(
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Rechazar Informe">
                                    <span>
                                        <ThumbDownAltIcon color="error" />
                                    </span>
                                </Tooltip>
                            }
                            onClick={async () => {
                                console.log(params.row)
                                setIdPrdOrdenProduccion(params.row.id);
                                toggleModalRechazar();
                            }}
                            hidden={params.row.estado === "Rechazado" ? true : false}
                            label="Rechazar Informe"
                        />,
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Motivo del rechazo">
                                    <span>
                                        <HelpIcon color="error" />
                                    </span>
                                </Tooltip>
                            }
                            onClick={async () => {
                                const historicoEstados = params.row?.prdCambioEstados?.historico_estados || [];
                                const result = getLastElementWithEstado3(esArray(historicoEstados));
                                console.log(historicoEstados)
                                setTittleSnackbar("Motivo del rechazo")
                                setMessage(result.detalle || "Sin detalle")
                                setSeverity("error");
                                setHideDisabled(true);
                                setSnackbarVisible(true);
                                //     setIdPrdOrdenProduccion(params.row.id);
                                //     toggleModalRechazar();
                            }}
                            hidden={params.row.estado === "Rechazado" ? false : true}
                            label="Rechazar Informe"
                        />
                    );
                }

                actions.push(
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Generar PDF">
                                <span>
                                    <PictureAsPdfIcon color="info" />
                                </span>
                            </Tooltip>
                        }
                        onClick={async () => {
                            const datos = await obtenerDetalle(params.row.id);
                            await generarPDF(datos);
                        }}
                        label="Generar PDF"
                    />,
                );


                return actions;
            },
        }
    ];

    function getLastElementWithEstado3(data) {
        // Filtrar los elementos que tienen id_prd_estados igual a 3
        const filteredItems = data.filter(item => item.id_prd_estados === "3");

        // Si no hay elementos filtrados, devolver null
        if (filteredItems.length === 0) {
            return null;
        }

        // Encontrar el elemento con el mayor id
        const maxIdItem = filteredItems.reduce((max, item) => {
            return parseInt(item.id) > parseInt(max.id) ? item : max;
        });

        return maxIdItem;
    }





    const toggleModalDetalle = () => {
        // setActualizarListado(true);
        setModalState(false);
    };

    const onSearch = (data) => {
        setIdElementData(data);
    };

    const obtenerDatosBusqueda = async () => {

        const clientes = await clientesForSearch({
            modelo: "cuentas_personas_juridicas",
            condiciones: []
        });
        const tecnicos = await cuentasFisicasForSearch({
            modelo: "cuentas_personas_fisicas",
            condiciones: []
        });
        const articulos = await articulosForSearch({
            modelo: "articulos",
            condiciones: []
        });

        const estados = await estadosInformesForSearch({
            modelo: "prd_estados",
            condiciones: []
        });


        const frutas = esArray(articulos.data).filter(item => item.id_articulos_tipo === "4");
        const maquinas = esArray(articulos.data).filter(item => item.id_articulos_tipo === "1");

        // Mapear para añadir la propiedad name
        const clientesConNombre = esArray(clientes.data).map(cliente => ({
            ...cliente,
            id: cliente.id_cuentas,
            name: `${cliente.id_cuentas} - ${cliente.razon_social}`
        }));

        const tecnicosConNombre = esArray(tecnicos.data).map(tecnico => ({
            ...tecnico,
            id: tecnico.id_cuentas,
            name: `${tecnico.id_cuentas} - ${tecnico.nombre} ${tecnico.apellido}`
        }));

        const frutasConNombre = frutas.map(fruta => ({
            ...fruta,
            name: `${fruta.id} - ${fruta.alias}`
        }));

        const maquinasConNombre = maquinas.map(maquina => ({
            ...maquina,
            name: `${maquina.id} - ${maquina.alias}`
        }));

        const estadosConNombre = esArray(estados.data).map(estado => ({
            ...estado,
            id: estado.id,
            name: `${estado.id} - ${estado.detalle}`
        }));


        const datosSelect = {
            clientes: clientesConNombre,
            tecnicos: tecnicosConNombre,
            estados: estadosConNombre,
            frutas: frutasConNombre,
            maquinas: maquinasConNombre
        };

        setModalName("Buscar");
        setChildModal(<SearchForm datos={datosSelect} onSearch={onSearch} toggleModal={toggleModalDetalle}></SearchForm>);
        setModalState(true);
    };

    const obtenerDetalle = async (id_informe) => {
        const response = await getInformeDetalle(id_informe);
        return response;
    };

    const generateExcel = async (props) => {
        const { totalPages, limit, idElementData } = props;
        let responseAcumulado = {
            data: [],
            total_records: 0
        };

        for (let i = 0; i < totalPages; i++) {
            let response;
            let offset = limit * i;

            if (idElementData !== undefined) {
                response = await getInformesPaginated2(limit, offset, idElementData);
            } else {
                response = await getInformesPaginated2(limit, offset);
            }

            if (response && response.data.length > 0) {
                const informes = esArray(response.data);
                responseAcumulado.data = responseAcumulado.data.concat(informes);
                responseAcumulado.total_records += informes.length;
            }
        }

        const datos_informes = responseAcumulado.data;

        const fileName = "Listado de Informes";
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Informe');

        // Agregar encabezados básicos
        const headers = [
            'Fecha de Carga', // A
            'Fecha de Armado', // B
            'Mes', // C
            'Maquina', // D
            'Fruta', // E
            'Tipo Armado', // F
            'Componente', // G 
            'Cliente',// H
            'Descripcion de articulo', // I
            'Articulo', // J
            'Cantidad de armado (total sin resta de scrap)', // K
            'Total fabricacion', // L 
            'Valor rotura_de_liner',// M
            '% Scrap', // N 
            'Tiempo HS', // O  
            'Productividad', // P 
            'Total mermas', // Q
            'Total Armado Aceptado', // R 
            'Id', // S
            'Valor regulacion_armado', // T
            'Valor regulacion_calidad', // U
            'Valor atascamiento', // V
            'Valor cajas_despegadas', // W
            'Valor problemas_de_hendido', // X
            'Valor descartonado', // Y
            'Valor troquelado', // Z
            'Valor impresion', // AA
            'Valor comba', // AB
            'Reventado',   // AC 
            'Valor delaminado', // AD
            'Valor mojadas', // AE
            'Sucias', // AF 
            'Valor rotas_por_palletizado', // AG
            'Valor maltratadas', // AH
            'Faltantes x Pallet', // AI No existe en el informe
            'Plancha N/A', // AJ Eliminar
            'Total horas cambioDeFormato', // AK
            'Falta HOTMELT', // AL generar el campo "Detenciones" - "Equipo Colero"
            'Falla Equipo', // AM Eliminar
            'Horas falla_alimentacion_electrica', // AN 
            'Horas falta_grua_horquilla', // AO
            'Horas falta_personal_palletizado', // AP
            'Horas falta_de_espacio', // AQ
            'Horas falta_pallet_base', // AR 
            'Horas horario_restringido', // AS
            'Calentamiento', // AT 
            'Total horas detenciones', // AU
            'HS Jornada', // AV
            'OT', // AW
            'Consumido de hotmelt', // AX
            'Observaciones', // AY
            'Técnico',// AZ
            'Localidad', // BA
            'Provincia', // BB
            'ZONA', // BC No existe en el informe
            'Estado', // BD 
            'Pallet Cartocor', // BE Eliminar


        ];

        const detencionesKeys = new Set();
        const mermasKeys = new Set();

        // Recorrer los informes para extraer las claves de detenciones y mermas
        datos_informes.forEach(item => {
            const detenciones = item.articulos?.detenciones || {};
            Object.keys(detenciones).forEach(key => detencionesKeys.add(key));

            const mermas = item.articulos?.mermas || {};
            Object.keys(mermas).forEach(key => mermasKeys.add(key));
        });

        // Agregar encabezados dinámicos para detenciones (principal y secundario)
        const detencionesHeaders = {};

        detencionesKeys.forEach(key => {
            const subDetenciones = datos_informes
                .map(item => item.articulos?.detenciones?.[key] || {})
                .reduce((acc, cur) => ({ ...acc, ...cur }), {});
            // let labelKey = key;

            // if (key === "total") {
            //     labelKey = "detenciones";
            // }
            // headers.push(`Total horas ${labelKey}`);
            // headers.push(`Total minutos ${labelKey}`);
            detencionesHeaders[key] = Object.keys(subDetenciones);

            // detencionesHeaders[key].forEach(subKey => {
            //     if (subKey !== "total_horas" && subKey !== "total_minutos") {
            //         headers.push(`Horas ${subKey}`);
            //         headers.push(`Minutos ${subKey}`);
            //     }
            // });
        });

        // Agregar encabezados dinámicos para mermas (principal y secundario)
        const mermasHeaders = {};

        mermasKeys.forEach(key => {
            const subMermas = datos_informes
                .map(item => item.articulos?.mermas?.[key] || {})
                .reduce((acc, cur) => ({ ...acc, ...cur }), {});
            // let labelKey = key;

            // if (key === "total") {
            //     labelKey = "mermas";
            // }
            // headers.push(`Total ${labelKey}`);
            if (key !== "total") {
                mermasHeaders[key] = Object.keys(subMermas);
            }

            // mermasHeaders[key]?.forEach(subKey => {
            //     headers.push(`Valor ${subKey}`);
            // });
        });

        const headerRow = worksheet.addRow(headers);

        // Estilos para encabezados
        headerRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Agregar datos
        datos_informes.forEach((item) => {
            const articulos = esArray(item.articulos) || [];
            const localizacion = item.localizacion || {};

            Array.isArray(articulos) && articulos.forEach((articulo) => {
                const estado = item?.estado || {};
                const produccion = articulo?.produccion || {};
                const detenciones = articulo?.detenciones || {};
                const mermas = articulo?.mermas || {};
                const cliente = articulo?.cliente || {};
                const fechaProduccion = produccion.fecha || '';
                const fechaCarga = item.fecha_creacion || '';
                const fechaISO = fechaProduccion.replace(' ', 'T');
                const mes = fechaISO ? new Date(fechaISO).toLocaleString('default', { month: 'long' }) : 'Fecha inválida';
                const maquina = articulo?.maquina?.alias || '';
                const tecnico = articulo?.tecnico?.nombre || '';
                const orden_trabajo = (typeof articulo?.orden_trabajo !== 'object' && articulo?.orden_trabajo !== null) ? articulo.orden_trabajo : "";
                let observaciones = item?.observaciones ? esArray(item.observaciones) : '';
                const componente = item.componente?.sin_valores === '1' ? 'Componente no cargado' : item.componente?.nombre;
                const total_horas_detenciones = item.total_detenciones.horas ? item.total_detenciones.horas : "0";

                if (observaciones !== "") {
                    observaciones = observaciones.map((obs, index) =>
                        `Observación ${index + 1}: ${obs.observaciones}`
                    ).join(', ');
                }

                const inicio = new Date(produccion.inicio);
                const fin = new Date(produccion.fin);

                const diferenciaEnMilisegundos = fin - inicio;

                const diferenciaEnHoras = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60));
                const diferenciaEnMinutos = Math.floor((diferenciaEnMilisegundos % (1000 * 60 * 60)) / (1000 * 60));
                const horasTrabajadas = diferenciaEnHoras + " Horas " + diferenciaEnMinutos + " Minutos";
                const row_header = {
                    'Fecha de Carga': fechaCarga, // A
                    'Fecha de Armado': fechaProduccion, // B
                    'Mes': mes, // C
                    'Maquina': maquina, // D
                    'Fruta': articulo?.fruta?.nombre || '', // E
                    'Tipo Armado': articulo?.tipo_armado?.nombre || '', // F
                    'Componente': componente, // G 
                    'Cliente': cliente.nombre,// H
                    'Descripcion de articulo': articulo?.articulo?.nombre || '', // I
                    'Articulo': articulo?.articulo?.alias || '', // J
                    'Cantidad de armado (total sin resta de scrap)': produccion.armado || 0, // K
                    'Total fabricacion': '', // L 
                    'Valor rotura_de_liner': '',// M
                    '% Scrap': '', // N 
                    'Tiempo HS': '', // O  
                    'Productividad': '', // P 
                    'Total mermas': '', // Q
                    'Total Armado Aceptado': '', // R 
                    'Id': item.id, // S
                    'Valor regulacion_armado': '', // T
                    'Valor regulacion_calidad': '', // U
                    'Valor atascamiento': '', // V
                    'Valor cajas_despegadas': '', // W
                    'Valor problemas_de_hendido': '', // X
                    'Valor descartonado': '', // Y
                    'Valor troquelado': '', // Z
                    'Valor impresion': '', // AA
                    'Valor comba': '', // AB
                    'Reventado': '',   // AC 
                    'Valor delaminado': '', // AD
                    'Valor mojadas': '', // AE
                    'Valor sucias': '', // AF 
                    'Valor rotas_por_palletizado': '', // AG
                    'Valor maltratadas': '', // AH
                    'Valor faltantes_por_pallet': '', // AI 
                    'Plancha N/A': '', // AJ Eliminar
                    'Total horas cambioDeFormato': '', // AK
                    'Horas falta_holmet': '', // AL 
                    'Falla Equipo': '', // AM Eliminar
                    'Horas falla_alimentacion_electrica': '', // AN 
                    'Horas falta_grua_horquilla': '', // AO
                    'Horas falta_personal_palletizado': '', // AP
                    'Horas falta_de_espacio': '', // AQ
                    'Horas falta_pallet_base': '', // AR 
                    'Horas horario_restringido': '', // AS
                    'Horas calentamiento': '', // AT 
                    'Total horas detenciones': total_horas_detenciones, // AU
                    'HS Jornada': horasTrabajadas, // AV
                    'OT': orden_trabajo, // AW
                    'Consumido de hotmelt': articulo.hotmelt || 0, // AX
                    'Observaciones': observaciones, // AY
                    'Técnico': tecnico,// AZ
                    'Localidad': localizacion.localidad || '', // BA
                    'Provincia': localizacion.provincia || '', // BB
                    'ZONA': '', // BC No existe en el informe
                    'Estado': estado, // BD 
                    'Pallet Cartocor': '', // BE Eliminar


                };
                for (const clave in row_header) {
                    if (row_header[clave] === '') {
                        const nuevoValor = buscarValorEnDetencionesOMermas(clave, detenciones, mermas, produccion, total_horas_detenciones);
                        if (nuevoValor !== '') {
                            row_header[clave] = nuevoValor;
                        }
                    }
                }

                const row = headers.map(header => row_header[header] ?? '');

                console.log("row", row);
                console.log("headers", headers);

                worksheet.addRow(row);
            });
        });

        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const cellLength = cell.value ? cell.value.toString().length : 10;
                if (cellLength > maxLength) {
                    maxLength = cellLength;
                }
            });
            column.width = maxLength + 2;
        });

        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            if (rowNumber !== 1) {
                row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });
            }
        });



        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `${fileName}.xlsx`);
        });
    };

    function buscarValorEnDetencionesOMermas(clave, detenciones, mermas, produccion, total_horas_detenciones) {
        let totalMermas = mermas?.total || 0;
        let totalHorasDetenciones = total_horas_detenciones || 0;
        console.log("detenciones?.total_horas", detenciones?.total_horas);
        // Buscar en detenciones
        for (const [key, det] of Object.entries(detenciones)) {
            if (key === clave && typeof det !== 'object') return det;
            if (typeof det === 'object') {
                for (const [subKey, subDet] of Object.entries(det)) {
                    if (`Valor ${subKey}` === clave || `Horas ${subKey}` === clave || `Minutos ${subKey}` === clave) {
                        if (typeof subDet === 'object') {
                            if (clave.includes('Horas')) return subDet.horas || 0;
                            if (clave.includes('Minutos')) return subDet.minutos || 0;
                            if (clave.includes('Valor')) return subDet.val || 0;
                        }
                    }
                }
            }
        }

        for (const [key, merma] of Object.entries(mermas)) {
            console.log("Buscando en:", key);

            if (key === clave && typeof merma !== 'object') {
                console.log("Match directo:", key, "=>", merma);
                return merma;
            }

            if (typeof merma === 'object') {
                for (const [subKey, subMerma] of Object.entries(merma)) {
                    const posibleClave = `Valor ${subKey}`;
                    if (posibleClave === clave) {
                        console.log("Match interno:", posibleClave, "=>", subMerma?.val);
                        return subMerma?.val || 0;
                    }
                }

                const posibleTotal = `Total ${key}`;
                if (posibleTotal === clave) {
                    const totalValue = Object.values(merma).reduce(
                        (sum, mer) => sum + Number(mer?.val || 0),
                        0
                    );
                    console.log("Match total:", posibleTotal, "=>", totalValue);
                    return totalValue || 0;
                }
            }
        }


        // Total mermas
        if (clave === 'Total mermas') {
            return totalMermas;
        }

        // Total armado aceptado
        if (clave === 'Total Armado Aceptado') {
            return (produccion?.armado || 0) - totalMermas;
        }

        // % Scrap
        if (clave === '% Scrap') {
            const armado = produccion?.armado || 0;
            if (armado === 0) return 0;
            return parseFloat(((totalMermas * 100) / armado).toFixed(2));
        }

        // % Tiempo HS
        if (clave === 'Tiempo HS') {
            if (produccion?.inicio && produccion?.fin) {
                const inicio = new Date(produccion.inicio);
                const fin = new Date(produccion.fin);

                const diffMs = fin - inicio;
                const diffHs = diffMs / (1000 * 60 * 60);

                return parseFloat(diffHs.toFixed(2));
            }
            return 0;
        }


        //'Productividad': Es el resultado de la división entre la columna "Total Armado" y  ("Hora Jornada" - "Total detenciones")
        if (clave === 'Productividad') {
            const totalArmado = Number(produccion?.armado) || 0;
            const totalMermasVal = Number(totalMermas) || 0;
            const totalHorasDetencionesVal = Number(totalHorasDetenciones) || 0;

            const totalArmadoAceptado = totalArmado - totalMermasVal;

            // Evitar división por cero
            if (totalHorasDetencionesVal <= 0) {
                return 0;
            }

            return totalArmadoAceptado / totalHorasDetencionesVal;
        }


        return ''; // No se encontró
    }





    const buttonBuscar = () => (
        <Button
            endIcon={<SearchIcon />}
            onClick={() => {
                obtenerDatosBusqueda()
            }}
            variant="contained"
            style={{
                color: '#FFFFFF',
                fontFamily: 'Roboto, sans-serif',
                minWidth: '120px',
                width: '120px',
                fontSize: '11px',
                height: '30px',
            }}
        >
            Buscar
        </Button>
    );

    const toggleModalConfirm = () => {
        setModalStateConfirm(!modalStateConfirm);
    };

    const toggleModalRechazar = () => {
        setModalStateRechazar(!modalStateRechazar);
    };

    const handleActualizarEstado = async (observacion) => {
        if (!observacion || observacion === '') {
            setHideDisabled(false);
            setTittleSnackbar(false)
            setMessage("Para poder rechazar el informe debe dejar un detalle o observación explicando el motivo.")
            setSeverity("warning");
            setSnackbarVisible(true);
            return;
        }
        const datos = {
            id_prd: idPrdOrdenProduccion,
            id_prd_estado: "3",
            detalle: observacion
        }
        const response = await estadoUpdate(datos);
        if (response.status === "false") {
            setHideDisabled(false);
            setTittleSnackbar(false)
            setMessage("No se pudo actualizar el estado !")
            setSeverity("warning");
            setSnackbarVisible(true);
        } else {
            setHideDisabled(false);
            setTittleSnackbar(false)
            setMessage("Informe rechazado correctamente!")
            setSeverity("success");
            setSnackbarVisible(true);
            setActualizarListado(true);
            toggleModalRechazar();
        }

    };

    const handleConfirmarEstado = async (observacion) => {
        if ((!observacion || observacion === '') && estadoInforme === "Rechazado") {
            setHideDisabled(false);
            setTittleSnackbar(false)
            setMessage("Para poder confirmar el informe debe dejar un detalle o observación explicando el motivo.")
            setSeverity("warning");
            setSnackbarVisible(true);
            return;
        }
        const datos = {
            id_prd: idPrdOrdenProduccion,
            id_prd_estado: "4",
            detalle: observacion
        }
        const response = await estadoUpdate(datos);
        if (response.status === "false") {
            setHideDisabled(false);
            setTittleSnackbar(false)
            setMessage("No se pudo actualizar el estado !")
            setSeverity("warning");
            setSnackbarVisible(true);
        } else {
            setHideDisabled(false);
            setTittleSnackbar(false)
            setMessage("Informe confirmado correctamente!")
            setSeverity("success");
            setSnackbarVisible(true);
            setActualizarListado(true);
            toggleModalConfirm();
        }

    };

    const handleHistorico = (historico) => {
        setHistoricoCambiosEstados(historico);
        toggleModalHistorico();
    };

    const toggleModalHistorico = async () => {
        setModalStateHistorico(!modalStateHistorico);

    };

    const InformesCard = ({ row }) => {
        const getColor = (estado) => {
            switch (estado) {
                case 'Confirmado':
                    return '#23A452';
                case 'Rechazado':
                    return '#C70039';
                default:
                    return '#2350A4';
            }
        };

        return (
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">ID</Typography>
                            <Typography variant="body2">{row.id}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">Numero</Typography>
                            <Typography variant="body2">{row.numero}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="caption" color="textSecondary">Cliente</Typography>
                            <Typography variant="body1" fontWeight="bold">{row.cliente_name}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">Fecha</Typography>
                            <Typography variant="body2">{row.fecha}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">Estado</Typography>
                            <Chip
                                label={row.estado}
                                size="small"
                                sx={{
                                    fontSize: '0.75rem',
                                    height: '24px',
                                    backgroundColor: getColor(row.estado),
                                    color: 'white'
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">Tecnico</Typography>
                            <Typography variant="body2">{row.tecnico}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">Maquina</Typography>
                            <Typography variant="body2">{row.maquina_name}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions disableSpacing>
                    <Tooltip title="Detalle">
                        <IconButton
                            onClick={async () => {
                                const datos = row;
                                setModalName("Detalles del Informe");
                                setChildModal(<InformeDetalle data={datos} />)
                                setModalState(true);
                            }}
                        >
                            <VisibilityIcon color="info" />
                        </IconButton>
                    </Tooltip>

                    {(idPerfil === "2" || idPerfil === "6") && (
                        <>
                            {row.estado !== "Confirmado" && (
                                <Tooltip title="Confirmar Informe">
                                    <IconButton
                                        onClick={async () => {
                                            setEstadoInforme(row.estado);
                                            setIdPrdOrdenProduccion(row.id);
                                            toggleModalConfirm();
                                        }}
                                    >
                                        <ThumbUpAltIcon color="success" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <Tooltip title="Cambios de Estado">
                                <IconButton
                                    onClick={async () => {
                                        const historicoEstados = row?.prdCambioEstados?.historico_estados || [];
                                        handleHistorico(historicoEstados);
                                    }}
                                >
                                    <HistoryIcon color="secondary" />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}

                    {(idPerfil === "2" || idPerfil === "6") && (
                        <>
                            {row.estado !== "Rechazado" && (
                                <Tooltip title="Rechazar Informe">
                                    <IconButton
                                        onClick={async () => {
                                            setIdPrdOrdenProduccion(row.id);
                                            toggleModalRechazar();
                                        }}
                                    >
                                        <ThumbDownAltIcon color="error" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {row.estado === "Rechazado" && (
                                <Tooltip title="Motivo del rechazo">
                                    <IconButton
                                        onClick={async () => {
                                            const historicoEstados = row?.prdCambioEstados?.historico_estados || [];
                                            const result = getLastElementWithEstado3(esArray(historicoEstados));
                                            setTittleSnackbar("Motivo del rechazo")
                                            setMessage(result.detalle || "Sin detalle")
                                            setSeverity("error");
                                            setHideDisabled(true);
                                            setSnackbarVisible(true);
                                        }}
                                    >
                                        <HelpIcon color="error" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </>
                    )}

                    {idPerfil !== "6" && (
                        <Tooltip title="Generar PDF">
                            <IconButton
                                onClick={async () => {
                                    const datos = await obtenerDetalle(row.id);
                                    await generarPDF(datos);
                                }}
                            >
                                <PictureAsPdfIcon color="info" />
                            </IconButton>
                        </Tooltip>
                    )}

                </CardActions>
            </Card>
        );
    };

    // eslint-disable-next-line no-unused-vars
    const [options, setOptions] = useState({
        cols: columns,
        get: getInformes,
        getPaginated: getInformesPaginated2,
        pageSize: [5, 10, 25],
        limit: 50,
        filter: true,
        exportData: true,
        server: true,
        exportarExcel: true,
        handleExportarExcel: generateExcel,
        buttonExtraOn: true,
        ButtonExtra: buttonBuscar,
        refresh: actualizarListado,
        mobileComponent: InformesCard,
    });


    useEffect(() => {

        setOptions({
            ...options,
            idElementData: idElementData
        });
        setModalState(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idElementData])

    useEffect(() => {
        if (actualizarListado) {
            setOptions({
                ...options,
                refresh: true,
            });
            setActualizarListado(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actualizarListado]);



    return (
        <>
            <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
                <HeaderTitleBreadcrumbs listName={"Informes"} />
                <SimpleDialogComponent
                    open={modalState}
                    modalName={modalName}
                    child={childModal}
                    handleClose={toggleModalDetalle}
                    buttonEnviar={false}
                    buttonCancelar={true}
                    maxWidth="lg"
                    fullscreen={isMobile}
                />
                <ConfimDialogComponent
                    maxWidth={'xs'}
                    open={modalStateRechazar}
                    modalName={"Aviso"}
                    mensaje={
                        "¿Esta seguro que desea rechazar el informe?"
                    }
                    handleConfirm={handleActualizarEstado}
                    handleClose={toggleModalRechazar}
                    enableObservations={true}
                />
                <ConfimDialogComponent
                    maxWidth={'xs'}
                    open={modalStateConfirm}
                    modalName={"Aviso"}
                    mensaje={
                        "¿Esta seguro que desea confirmar el informe?"
                    }
                    handleConfirm={handleConfirmarEstado}
                    handleClose={toggleModalConfirm}
                    enableObservations={true}
                />
                <SnackbarMessenger
                    open={snackbarVisible}
                    message={message}
                    severity={severity}
                    close={() => {
                        setSnackbarVisible(false);
                    }}
                    hideDisabled={hideDisabled}
                    title={tittleSnackbar}
                />

                <SimpleDialogComponent
                    open={modalStateHistorico}
                    modalName={"Historico"}
                    child={<HistoricoCambioEstadoInformeProduccion data={historicoCambiosEstados} />}
                    setPushData={toggleModalHistorico}
                    handleClose={toggleModalHistorico}
                    buttonEnviar={false}
                    buttonCancelar={true}
                />

                <ListTablePaginated options={options} />
            </Grid>
        </>
    );
};
